import { TextInput } from '@mantine/core';
import { ReactNode } from 'react';
import { FieldValues, useController } from 'react-hook-form';

import { FormControlInput } from '@/core/components';

export interface TextInputControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;
  description?: string;
  placeholder?: string;

  isDisabled?: boolean;

  leftSection?: ReactNode;
  leftSectionWidth?: string;
}

export function TextInputControl<T extends FieldValues>(props: TextInputControlProps<T>) {
  const {
    withAsterisk,
    label,
    placeholder,
    description,
    name,
    isSubmitting,
    isDisabled,
    leftSection,
    leftSectionWidth,
    control,
  } = props;
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <TextInput
      ref={field.ref}
      name={field.name}
      value={field.value}
      onChange={field.onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      withAsterisk={withAsterisk}
      error={error?.message}
      disabled={isSubmitting || isDisabled}
      flex={1}
      leftSection={leftSection}
      leftSectionWidth={leftSectionWidth}
    />
  );
}
